import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ChangePassword from '../ui/account/changePassword.jsx';
import Manage from '../ui/account/manage.jsx';
import Home from '../ui/home/home.jsx';
import ImpostazioniMasterPage from '../ui/impostazioni/impostazioniMasterPage.jsx';
import NotFound from '../ui/NotFoundPage.jsx';
// import Documenti from './documenti/Documenti.jsx';
import DataSourceMasterPage from './dataSource/dataSourceMasterPage.jsx';
import DocumentiList from './documenti/DocumentiList.jsx';
import DocumentiDetails from './documenti/DocumentiDetails.jsx';
import NuovoDoc from './documenti/NuovoDoc.jsx';
import Footer from './Footer.jsx';
import MenuTop from './MenuTop.jsx';
import Utilities from './utilities/Utilities.jsx';

class MasterPage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MasterPage.jsx] ';
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div role="document" >

                <MenuTop />
                <div className="container-fluid" role="main">
                    <Switch>
                        <Redirect exact="true" from="/" to="/home" />
                        <Route path="/home" component={Home} />
                        <Route path="/documenti" component={DocumentiList} />
                        <Route path="/documentiDetails" component={DocumentiDetails}></Route>
                        <Route path="/dataSource" component={DataSourceMasterPage} />
                        <Route path="/utilities" component={Utilities} />
                        <Route path="/nuovoDoc" component={NuovoDoc} />
                        <Route path="/impostazioni" component={ImpostazioniMasterPage} />
                        <Route path="/account/manage" component={Manage} />
                        <Route path="/account/changePassword" component={ChangePassword} />
                        <Route component={NotFound} />
                    </Switch>
                </div>
                <Footer />
            </div>
        )
    }
}


export default MasterPage;